import { ChangeDetectorRef, Component, ComponentFactoryResolver, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';

import { ComponentService } from '../../services/component.service';
import { FormsTemplateService } from '../../services/forms-template.service';
import { NicaAnagraficaComponent } from '../../components/nica-anagrafica/nica-anagrafica.component';
import { NicaFormComponent } from '../../components/nica-form/nica-form.component';

import { OverlaySideFormService } from '../../components/shared/overlay-side-form/overlay-side-form.service';
import { RentriService } from '../../services/rentri.service';
import { AnagraficaService } from '../../services/anagrafica.service';
import { NicaMaster } from '../../components/nica-master-component/nica-master.component';
import { NicaMenuService } from '../../services/nica-menu.service';
import { HttpClient } from '@angular/common/http';
import { alert } from 'devextreme/ui/dialog';
import { Apiservice } from '../../services/api.service';

@Component({
  selector: 'app-causalirifiuti',
  templateUrl: './causalirifiuti.component.html',
  styleUrls: ['./causalirifiuti.component.css']
})
export class CausalirifiutiComponent extends NicaMaster implements OnInit {

  @ViewChild('uCausali', { static: false }) uCausali: NicaAnagraficaComponent;
  @Input() itemData: any

  arrayRegistri: any[];
  casualeTabs: any[];
  templateTab: any = {
    CausaliRifiuti: 'grid',
    CausaliAvanzate: 'form',
    PosizioneCausale: 'grid'
  }
  selectedIndex: any =
    {

      CausaliRifiuti: 0,
      CausaliAvanzate: 2,
      PosizioneCausale: 1

    }
  params: any;
  posizioni: any;
  escludiRegistroValue: any;



  constructor(
    public userComponentService: ComponentService,
    public templateService: FormsTemplateService,
    public _overlaySideFormService: OverlaySideFormService,
    public _overlaySidePanelService: OverlaySideFormService,
    public formTemplateService: FormsTemplateService,
    public _componentFactoryResolver: ComponentFactoryResolver,
    public activatedroute: ActivatedRoute,
    public router: Router,
    public menuService: NicaMenuService,
    public rentriService: RentriService,
    public anagraficaService: AnagraficaService,
    private api: Apiservice,
    private readonly cdrf: ChangeDetectorRef

  ) {
    super(
      userComponentService,
      templateService,
      _overlaySideFormService,
      _overlaySidePanelService,
      formTemplateService,
      _componentFactoryResolver,
      activatedroute,
      router,
      menuService,
      rentriService,
      anagraficaService,


    );

    this.api.GetApi('RegistroRifiuti').then((res: any) => {
      this.arrayRegistri = res
      console.log('posizioniCausaliFormRender', this.arrayRegistri)
    })
    console.log('posizioniCausaliFormRender', this.arrayRegistri)
  }

  ngAfterViewInit(): void {

    if (this.SubjectCall == 'PosizioneCausale' && this.template == 'grid') {
      this.causaleGridRender()

    }
  }

  ngOnInit() {


    this.activatedroute.queryParams
      .subscribe(params => {


        this.currentTabId = params.currentTabId;
        this.currentTabName = params.currentTabName;
        this.setGlobalVariableFromParams(params)


      });


    this.casualeTabs = [
      {
        name: 'Causale rifiuti',
        icon: 'glyphicon icon-causalerifiuti-form',
        hint: 'Autorizzazion',
        displayMode: 'in-line',
        path: 'main/configurazione-causali-gestione-rifiuti',
        componentName: 'CausalirifiutiComponent',
        service: 'CausaliRifiuti',
        api: 'CausaliRifiuti',
        templateComponent: this.templateTab['CausaliRifiuti'],
        visible: true,
        disabled: false
      },
      {
        name: 'Posizioni',
        icon: 'glyphicon icon-causalerifiuti-form',
        hint: 'Posizioni della causale ',
        displayMode: 'in-line',
        path: 'main/configurazione-causali-gestione-rifiuti',
        componentName: 'CausalirifiutiComponent',
        service: 'PosizioneCausale',
        api: 'PosizioneCausale',
        templateComponent: this.templateTab['PosizioneCausale'],
        visible: true,
        disabled: this.filterID['idCausale'] ? false : true

      },
      {
        name: 'Avanzate',
        icon: 'glyphicon icon-causalerifiuti-form',
        hint: 'Opzioni avanzate ',
        displayMode: 'in-line',
        path: 'main/configurazione-causali-gestione-rifiuti',
        componentName: 'CausalirifiutiComponent',
        service: 'CausaliAvanzate',
        api: 'CausaliRifiuti',
        templateComponent: 'form',
        visible: true,
        disabled: this.id || this.filterID['idCausale'] ? false : true

      },

    ]

    if (this.SubjectCall == 'CausaliRifiuti' && this.template == 'grid') {

      this.filterGrid = '?$orderby=idTipoOperazione asc'

    }


  }




  async formItemsEventCausali(e) {

    console.log('formItemsEventCausali-->', e)

    if (e.name == "onValueChanged") {
      const trasporto = e.formData.trasporto
      const idOperazione = e.formData.idOperazione
      const categoria = this.filterID['idOperazione']

      if (e.campo.dataField === 'idTrasportatore' && e.formData.idTrasportatore !== null) {
        e.masterComponent.elementRef.idRegistroTrasporto.component.optionData = this.arrayRegistri.filter(i => i.idSede == e.formData.idTrasportatore)
        this.formAnagrafica.itemOption('datiTrasportatore.idRegistroTrasporto', 'disabled', e.formData['idTrasportatore'] === null)
      }
      if (e.campo.dataField === 'idDestinatario' && e.formData.idDestinatario !== null) {
        this.formAnagrafica.itemOption('datiSmaltimento.idRegistroCarico', 'disabled', e.formData['idDestinatario'] === null)
        e.masterComponent.elementRef.idRegistroCarico.component.optionData = this.arrayRegistri.filter(i => i.idSede == e.formData.idDestinatario)
      }
      if (e.campo.dataField === 'idIntermediario' && e.formData.idIntermediario !== null) {
        e.masterComponent.elementRef.idRegistroIntermediario.component.optionData = this.arrayRegistri.filter(i => i.idSede == e.formData.idIntermediario)
        this.formAnagrafica.itemOption('datiIntermediario.idRegistroIntermediario', 'disabled', e.formData['idIntermediario'] === null)
      }
      if (e.campo.dataField === 'idProduttore' && e.formData.idProduttore !== null) {
        e.masterComponent.elementRef.idRegistroScarico.component.optionData = this.arrayRegistri.filter(i => i.idSede == e.formData.idProduttore)
        this.formAnagrafica.itemOption('datiProduttore.idRegistroScarico', 'disabled', e.formData['idProduttore'] === null)
      }

      if (e.campo.dataField == "idOperazione" || e.campo.dataField == 'trasporto' || e.campo.dataField == 'prodottoDaGestione') {
        if (e.formData.idOperazione == 'A1' || e.formData.idOperazione == 'A4' || e.formData.idOperazione == 'A5' || e.formData.idOperazione == 'B2' || e.formData.idOperazione == 'C1' || e.formData.idOperazione == 'B3') {

          if (e.formData.idOperazione == 'B2' || e.formData.idOperazione == "B3") {
            this.formAnagrafica.itemOption('altreInformazioni.spurghi', 'disabled', false);
          } else if (e.formData.idOperazione == 'A1' && e.formData.prodottoDaGestione == 'N' && e.formData.trasporto == 'P') {
            this.formAnagrafica.itemOption('altreInformazioni.spurghi', 'disabled', false);
          } else if ((e.formData.idOperazione == 'A4' || e.formData.idOperazione == 'A5' || e.formData.idOperazione == 'C1') && e.formData.trasporto == 'P') {
            this.formAnagrafica.itemOption('altreInformazioni.spurghi', 'disabled', false);
          } else {
            this.formAnagrafica.itemOption('altreInformazioni.spurghi', 'disabled', true);
          }

        } else {
          this.formAnagrafica.itemOption('altreInformazioni.spurghi', 'disabled', true);
        }
      }

      if (e.campo.dataField == "spurghi") {

        if (trasporto && idOperazione) {

          if (e.value && trasporto != 'P' && (idOperazione != 'B2' || idOperazione != 'B3')) {
            if (idOperazione == 'B2' || idOperazione == 'B3' || idOperazione == 'C1') {
              return
            }
            alert('Il trasporto deve essere in conto proprio', 'Attenzione!');
            // e.value = false;
            e.component.option('value', false)
            //this.formAnagrafica.formRefreshInputData('trasporto','P')
          }

        }

        const prodottoDaGestione = e.formData.prodottoDaGestione;
        if (prodottoDaGestione && idOperazione) {
          if (e.value && prodottoDaGestione == 'S' && idOperazione == 'A1') {
            alert('Il Prodotto da gestione deve essere No', 'Attenzione!');
            e.component.option('value', false)
            //this.formAnagrafica.formRefreshInputData('prodottoDaGestione', 'S');
          }
        }
      }

      if (e.campo.dataField == 'prodottoDaGestione') {

        const spurghi = e.formData.spurghi
        if (idOperazione && spurghi) {
          if (e.value == 'S' && spurghi && idOperazione == 'A1') {
            alert('Prodotto da gestione è Si, spurghi e ammasso solo se prodotto da gestione è No', 'Attenzione!');
            this.formAnagrafica.formRefreshInputData('spurghi', false)
          }
          const obbligoFuoriUL = this.formAnagrafica.dataSet.obbligoFuoriUL;
          if (e.value == 'S' && obbligoFuoriUL && (idOperazione == 'A1' || idOperazione == 'A2' || idOperazione == 'A3')) {
            alert('Prodotto da gestione è Si, Obbligo Fuori UL ammesso solo se prodotto da gestione è No', 'Attenzione!');
            this.formAnagrafica.formRefreshInputData('obbligoFuoriUL', false)
          }
        }
      }

      if (e.campo.dataField == 'obbligoFuoriUL') {
        const idOperazione = this.formAnagrafica.dataSet.idOperazione;
        const prodottoDaGestione = this.formAnagrafica.dataSet.prodottoDaGestione;
        if ((e.value && prodottoDaGestione == 'S') && (idOperazione == 'A1' || idOperazione == 'A2' || idOperazione == 'A3')) {
          alert('Per Obbligo Fuori UL, il prodotto da gestione deve essere no', 'Attenzione!');
          this.formAnagrafica.formRefreshInputData('obbligoFuoriUL', false)
        }
        const trasporto = this.formAnagrafica.dataSet.trasporto
        if ((e.value && trasporto == 'N') && (idOperazione == 'A2' || idOperazione == 'A3' || idOperazione == 'B2' || idOperazione == 'B3')) {
          alert('Obbligo Fuori UL, non è ammasso se trasporto è:Nessun trasporto', 'Attenzione!');
          this.formAnagrafica.formRefreshInputData('obbligoFuoriUL', false);
        }
      }

      if (e.campo.dataField == 'attivaRintracciabilita') {
        if (e.value) {
          this.formAnagrafica.formRefreshInputData('caricoDaMiscelazione', false)
        }
      }
      if (e.campo.dataField == 'caricoDaMiscelazione') {
        if (e.value) {
          this.formAnagrafica.formRefreshInputData('attivaRintracciabilita', false)
        }
      }

      if (e.campo.dataField == 'idTipoOperazione') {

        console.warn('cambiato tipo operazione', e);

        let data = await this.anagraficaService.getElenco('OperazioneCausaleRifiuti/GetAllByTipoOperazione', '', `?TipoOperazione=${e.value}`);

        if (data['items']) {

          const compoEditorType = this.formAnagrafica.getInputsComponents('idOperazione');
          compoEditorType.component.optionData = data['items'];

          //const opt =  compoEditorType.component.optionData.filter(res=>res.dataType == value);


          // compoEditorType.component.optionData = opt 
        }


      }
      const formData = e.formData


      if (categoria == 'A1' || categoria == 'A2' || categoria == 'A3' || categoria == 'A8' || categoria == 'B1') { //&& this.filterID['isEdit']
        // if (e.campo.dataField == 'descrizioneSede_IdProduttore') {
        this.formAnagrafica.formRefreshInputData('idDestinatario', formData.idProduttore);
        this.formAnagrafica.formRefreshInputData('descrizioneSede_IdDestinatario', formData.descrizioneSede_IdProduttore);
        this.formAnagrafica.formRefreshInputData('idSedeRentriDestinatario', formData.idSedeRentri);
        //}
      }

      if (idOperazione === 'A2' || idOperazione === 'A1' || idOperazione === 'A6' || idOperazione === 'A7') {
        this.formAnagrafica.itemOption('datiProduttore.idRegistroScarico', 'disabled', true)
        this.formAnagrafica.itemOption('datiSmaltimento.idRegistroCarico', 'disabled', false)
        if (e.formData.idDestinatario !== null) e.masterComponent.elementRef.idRegistroCarico.component.optionData = this.arrayRegistri.filter(i => i.idSede == e.formData.idDestinatario)
      }
      if (idOperazione === 'A8') {
        this.formAnagrafica.itemOption('datiProduttore.idRegistroScarico', 'disabled', false)
        this.formAnagrafica.itemOption('datiSmaltimento.idRegistroCarico', 'disabled', true)
        if (e.formData.idProduttore !== null) e.masterComponent.elementRef.idRegistroScarico.component.optionData = this.arrayRegistri.filter(i => i.idSede == e.formData.idProduttore)
      }
      if (idOperazione == 'A4' || idOperazione == 'A5') {
        this.formAnagrafica.itemOption('datiSmaltimento.idRegistroCarico', 'disabled', false)
        e.masterComponent.elementRef.idRegistroCarico.component.optionData = this.arrayRegistri.filter(i => i.idSede == e.formData.idDestinatario)
      }
      if (idOperazione === 'A2' && e.formData.idProduttore) {
        e.masterComponent.elementRef.idRegistroCarico.component.optionData = this.arrayRegistri.filter(i => i.idSede == e.formData.idProduttore)
      }
      if (idOperazione === 'A1' && e.formData.idProduttore) {
        e.masterComponent.elementRef.idRegistroCarico.component.optionData = this.arrayRegistri.filter(i => i.idSede == e.formData.idProduttore)
      }
      if (idOperazione === 'A3' && e.formData.idProduttore) {
        e.masterComponent.elementRef.idRegistroCarico.component.optionData = this.arrayRegistri.filter(i => i.idSede == e.formData.idProduttore)
      }
      this.cdrf.detectChanges()
    }

    if (e.name == 'selectedItemLista') {

      if (e.campo.dataField == 'idOperazione') {

        const idOper = e.value;

        if (!this.filterID['isEdit'] && typeof this.posizioni == 'undefined') {
          this.formAnagrafica.formRefreshInputData('spurghi', false);
          this.formAnagrafica.formRefreshInputData('obbligoFuoriUL', false);
          this.formAnagrafica.formRefreshInputData('trasporto', null);
          this.formAnagrafica.formRefreshInputData('prodottoDaGestione', null);
          this.formAnagrafica.itemOption('causaleRifiuti.trasporto', 'disabled', false);
          this.formAnagrafica.itemOption('causaleRifiuti.prodottoDaGestione', 'disabled', true);
          // this.formAnagrafica.itemOption('causaleRifiuti.listaOperazioniRD', 'disabled', true);
          // this.formAnagrafica.itemOption('altreInformazioni.spurghi', 'disabled', true);
          this.formAnagrafica.itemOption('altreInformazioni.obbligoFuoriUL', 'disabled', true);


          if (idOper) {
            let desc = this.formAnagrafica.dataSet.descrizione;
            if (desc) {
              let espressioneRegolare = /\b[a-zA-Z]\d\s*- /g;
              let nuovaStringa = desc.replace(espressioneRegolare, '');
              let newDesc = idOper + ' - ' + nuovaStringa;
              if (newDesc.length >= 60) {
                newDesc = newDesc.slice(0, 59);
              }
              this.formAnagrafica.formRefreshInputData('descrizione', newDesc);
            } else {
              let newDesc = idOper + ' - ' + e.selectedElement['descrizione']

              if (newDesc.length >= 60) {
                newDesc = newDesc.slice(0, 60);
              }
              this.formAnagrafica.formRefreshInputData('descrizione', newDesc);
            }
          }
        }

        if (idOper == 'A1' || idOper == 'A2' || idOper == 'A3') {


          this.formAnagrafica.itemOption('causaleRifiuti.prodottoDaGestione', 'disabled', false);
          this.formAnagrafica.itemOption('causaleRifiuti.prodottoDaGestione', 'setLabel', "Prod.da lavorazione rifiuti")


        }



        if (idOper == 'A8' || idOper == 'B1') {

          // this.formAnagrafica.itemOption('causaleRifiuti.listaOperazioniRD', 'disabled', true);

          // //se nascondo pulisco il campo;
          // this.formAnagrafica.formRefreshInputData('listaOperazioniRD', null);

          this.formAnagrafica.formRefreshInputData('trasporto', 'N');
          this.formAnagrafica.itemOption('causaleRifiuti.trasporto', 'disabled', true);


        }


        if (idOper == 'A1' || idOper == 'A2' || idOper == 'A3' || idOper == 'B2' || idOper == 'B3') {
          this.formAnagrafica.itemOption('altreInformazioni.obbligoFuoriUL', 'disabled', false);
        }
        if (idOper == 'C1') {
          this.formAnagrafica.formRefreshInputData('trasporto', 'P');
          this.formAnagrafica.itemOption('causaleRifiuti.trasporto', 'disabled', true);

        }

        if (idOper == 'C2') {

          this.formAnagrafica.formRefreshInputData('trasporto', 'T');
          this.formAnagrafica.itemOption('causaleRifiuti.trasporto', 'disabled', true);


        }

      }


      if (e.campo.dataField == 'trasporto') {
        const spurghi = e.formData.spurghi
        const idOperazione = e.formData.idOperazione
        if (!e.value) {
          return
        }
        if (e.value != 'P' && spurghi && (idOperazione != 'B2' || idOperazione != 'B3')) {
          if (idOperazione == 'B2' || idOperazione == 'B3' || idOperazione == 'C1') {
            return
          }

          alert('Il trasporto deve essere in conto proprio se selezioni spurghi', 'Attenzione!')
        }

        if ((idOperazione == 'A2' || idOperazione == 'A3' || idOperazione == 'B2' || idOperazione == 'B3')) {

          const obbligoFuoriUL = e.formData.obbligoFuoriUL;

          if (obbligoFuoriUL && e.value == 'N') {
            alert('Il trasporto deve essere diverso da nessuno, se selezioni Obbligo fuori UL', 'Attenzione!');
            this.formAnagrafica.formRefreshInputData('obbligoFuoriUL', false);
          }
        }

      }
    }




    if (e.eventName == 'submittedInsertOk') {

      let template = 'form'
      this.id = e[this.masterKey];

      let data = e
      /**Gestisco i queryurl Filtri in Base al Edit**/
      if (this.anagraficaDati[0]['configuration']['queryFilter']) {
        let arrayIdRif = this.anagraficaDati[0]['configuration']['queryFilter'] // prendo i campi di riferimento da passare alla Form dalla configurazione
        let newItem
        arrayIdRif.forEach(idTab => {

          if (typeof data[idTab['value']] != 'undefined') {

            newItem = { ...this.filterID, [idTab['key']]: data[idTab['value']] };
            this.filterID = newItem;
          }
        });

      }

      if (this.SubjectCall == 'PosizioneCausale') {
        template = 'grid'
      }
      this.filterID['isEdit'] = true;

      this.refreshPage(data, 'Modifica', this.SubjectCall, template);
      return


    }

    if (e.eventName == 'submittedEditOk') {
      let template = 'form'

      let data = this.formAnagrafica.dataSet;

      /**Gestisco i queryurl Filtri in Base al Edit**/
      if (this.anagraficaDati[0]['configuration']['queryFilter']) {
        let arrayIdRif = this.anagraficaDati[0]['configuration']['queryFilter'] // prendo i campi di riferimento da passare alla Form dalla configurazione
        let newItem
        arrayIdRif.forEach(idTab => {

          if (typeof data[idTab['value']] != 'undefined') {

            newItem = { ...this.filterID, [idTab['key']]: data[idTab['value']] };
            this.filterID = newItem;
          }
        });



      }
      if (this.SubjectCall == 'PosizioneCausale') {
        template = 'grid'
      }
      this.refreshPage(data, '', this.SubjectCall, template);
      return
    }


    if (e.name == 'return') {

      let returnTo = 'CausaliRifiuti'

      /**Gestisco i queryurl Filtri in Base al filtri iniziali**/
      if (this.anagraficaDati[0]['configuration']['queryFilter']) {

        let arrayIdRif = this.anagraficaDati[0]['configuration']['queryFilter'] // prendo i campi di riferimento da passare alla Form dalla configurazione
        let newItem
        let data = this.formAnagrafica.dataSet

        arrayIdRif.forEach(idTab => {

          if (typeof data[idTab['value']] != 'undefined') {

            //this.filterID[idTab['key']]=data[idTab['value']]
            newItem = { ...data, [idTab['key']]: data[idTab['value']] };
            this.filterID = newItem;


          }
        });



      }

      if (this.SubjectCall == 'CausaliRifiuti' || this.SubjectCall == 'CausaliAvanzate') {

        this.filterID = [];
      }
      if (this.SubjectCall == 'PosizioneCausale') {

        returnTo = 'PosizioneCausale'
      }

      this.refreshPage([], 'Elenco', returnTo, 'grid');
      return

    }




  }


  /******************Modfifica la griglia delle Posizioni******************/
  causaleGridRender() {

    if (this.template == 'grid' && this.SubjectCall == 'PosizioneCausale') {


      const idOperazione = this.filterID['idOperazione'];
      const trasporto = this.filterID['trasporto']

      //Abilita le colonne relativi al produttore;

      if (idOperazione == 'A1' || idOperazione == 'A2') {

        this.uCausali.griglia.instance.columnOption('idProduttore', 'visible', true);
        this.uCausali.griglia.instance.columnOption('idDestinatario', 'visible', true);
        this.uCausali.griglia.instance.columnOption('idRegistroScarico', 'visible', false);
        this.uCausali.griglia.instance.columnOption('idRegistroCarico', 'visible', true);
        //this.uCausali.griglia.instance.columnOption('idRegistroRentriScarico', 'cssClass', '');
      }
      if (idOperazione == 'A3') {

        this.uCausali.griglia.instance.columnOption('idProduttore', 'visible', true);
        this.uCausali.griglia.instance.columnOption('idDestinatario', 'visible', true);
        this.uCausali.griglia.instance.columnOption('idRegistroScarico', 'visible', true);
        this.uCausali.griglia.instance.columnOption('idRegistroCarico', 'visible', true);
      }
      if (idOperazione == 'A4' || idOperazione == 'A5') {

        this.uCausali.griglia.instance.columnOption('idProduttore', 'visible', false);
        this.uCausali.griglia.instance.columnOption('idDestinatario', 'visible', true);
        this.uCausali.griglia.instance.columnOption('idRegistroScarico', 'visible', false);
        this.uCausali.griglia.instance.columnOption('idRegistroCarico', 'visible', true);
      }

      if (idOperazione == 'A6' || idOperazione == 'A7' || idOperazione == 'A8') {

        this.uCausali.griglia.instance.columnOption('idProduttore', 'visible', true);
        this.uCausali.griglia.instance.columnOption('idDestinatario', 'visible', true);
        this.uCausali.griglia.instance.columnOption('idRegistroScarico', 'visible', false);
        this.uCausali.griglia.instance.columnOption('idRegistroCarico', 'visible', true);

      }

      if (trasporto == 'P' || trasporto == 'X') {

        this.uCausali.griglia.instance.columnOption('idTrasportatore', 'visible', true);
        this.uCausali.griglia.instance.columnOption('idRegistroTrasporto', 'visible', true);


      }

      //Abilita le colonne relativi al destinatario;

      if (idOperazione == 'B1') {

        this.uCausali.griglia.instance.columnOption('idProduttore', 'visible', true);
        this.uCausali.griglia.instance.columnOption('idDestinatario', 'visible', true);
        this.uCausali.griglia.instance.columnOption('idRegistroScarico', 'visible', true);
        this.uCausali.griglia.instance.columnOption('idRegistroCarico', 'visible', true);
      }

      if (idOperazione == 'B2') {
        this.uCausali.griglia.instance.columnOption('idProduttore', 'visible', true);
        this.uCausali.griglia.instance.columnOption('idDestinatario', 'visible', false);
        this.uCausali.griglia.instance.columnOption('idRegistroScarico', 'visible', true);
        this.uCausali.griglia.instance.columnOption('idRegistroCarico', 'visible', false);
      }

      if (idOperazione == 'B3') {
        this.uCausali.griglia.instance.columnOption('idProduttore', 'visible', true);
        this.uCausali.griglia.instance.columnOption('idDestinatario', 'visible', true);
        this.uCausali.griglia.instance.columnOption('idRegistroScarico', 'visible', true);
        this.uCausali.griglia.instance.columnOption('idRegistroCarico', 'visible', false);

      }
      if (idOperazione == 'C1') {
        this.uCausali.griglia.instance.columnOption('idTrasportatore', 'visible', true);
        this.uCausali.griglia.instance.columnOption('idRegistroTrasporto', 'visible', true);
        //this.uCausali.griglia.instance.columnOption('idRegistroRentriTrasporto', 'cssClass', '');

      }

      if (idOperazione == 'C2') {
        this.uCausali.griglia.instance.columnOption('idIntermediario', 'visible', true);
        this.uCausali.griglia.instance.columnOption('idRegistroIntermediario', 'visible', true);
        //this.uCausali.griglia.instance.columnOption('idRegistroRentriTrasporto', 'cssClass', '');

      }




    }



  }

  /******************Modfifica la Form delle Causali in Edit******************/

  renderFormCausali(e) {
    if (e.name == 'formContentInitializzed') {

      if (this.SubjectCall == 'CausaliRifiuti' && this.filterID['isEdit']) {

        const idOper = e.formData.idOperazione;

        if (idOper == 'A1' || idOper == 'A2' || idOper == 'A3') {


          this.formAnagrafica.itemOption('causaleRifiuti.prodottoDaGestione', 'setLabel', 'Prod.da lavorazione rifiuti');
          this.formAnagrafica.itemOption('causaleRifiuti.prodottoDaGestione', 'cssClass', '');

          //e.component.getEditor('prodottoDaGestione').option('value', 'S')


        } else {

          this.formAnagrafica.itemOption('causaleRifiuti.prodottoDaGestione', 'disabled', true);

          this.formAnagrafica.itemOption('causaleRifiuti.prodottoDaGestione', 'setLabel', 'Prodotto da gestione');
        }


        if (idOper == 'A8' || idOper == 'B1') {


          // this.formAnagrafica.itemOption('causaleRifiuti.listaOperazioniRD', 'disabled', true);
          // this.formAnagrafica.itemOption('causaleRifiuti.listaOperazioniRDDesc', 'cssClass', 'd-none');

        }

        if (idOper == 'A1' || idOper == 'A2' || idOper == 'A3' || idOper == 'B2' || idOper == 'B3') {
          this.formAnagrafica.itemOption('altreInformazioni.obbligoFuoriUL', 'disabled', false);
        } else {
          this.formAnagrafica.itemOption('altreInformazioni.obbligoFuoriUL', 'disabled', true);
        }

        if (e.formData.idOperazione == 'A1' || e.formData.idOperazione == 'A4' || e.formData.idOperazione == 'A5' || e.formData.idOperazione == 'B2' || e.formData.idOperazione == 'C1' || e.formData.idOperazione == 'B3') {

          if (e.formData.idOperazione == 'B2' || e.formData.idOperazione == "B3") {
            this.formAnagrafica.itemOption('altreInformazioni.spurghi', 'disabled', false);
          } else if (e.formData.idOperazione == 'A1' && e.formData.prodottoDaGestione == 'N' && e.formData.trasporto == 'P') {
            this.formAnagrafica.itemOption('altreInformazioni.spurghi', 'disabled', false);
          } else if ((e.formData.idOperazione == 'A4' || e.formData.idOperazione == 'A5' || e.formData.idOperazione == 'C1') && e.formData.trasporto == 'P') {
            this.formAnagrafica.itemOption('altreInformazioni.spurghi', 'disabled', false);
          } else {
            this.formAnagrafica.itemOption('altreInformazioni.spurghi', 'disabled', true);
          }

        } else {
          this.formAnagrafica.itemOption('altreInformazioni.spurghi', 'disabled', true);
        }


        if (idOper == 'A1' || idOper == 'A2' || idOper == 'A3' || idOper == 'A4' || idOper == 'A5' || idOper == 'A6' || idOper == 'A7'
          || idOper == 'B2' || idOper == 'B3' || idOper == 'D1' || idOper == 'D2' || idOper == 'D3'
        ) {

          this.formAnagrafica.itemOption('causaleRifiuti.trasporto', 'disabled', false);

        }

        if (idOper == 'B1' || idOper == 'A8') {
          this.formAnagrafica.itemOption('causaleRifiuti.trasporto', 'disabled', true);
          this.formAnagrafica.formRefreshInputData('trasporto', 'N')
        }

        if (idOper == 'C1') {
          this.formAnagrafica.itemOption('causaleRifiuti.trasporto', 'disabled', true);
          this.formAnagrafica.formRefreshInputData('trasporto', 'P')
        }

        if (idOper == 'C2') {
          this.formAnagrafica.itemOption('causaleRifiuti.trasporto', 'disabled', true);
          this.formAnagrafica.formRefreshInputData('trasporto', 'T')
        }

        const queryString = "?idCausale=" + this.id;

        this.anagraficaService.getElenco('PosizioneCausale', '', queryString).then(result => {



          if (result['items']) {
            this.posizioni = result['items'];
          } else {
            this.posizioni = result;
          }
          if (typeof this.posizioni == 'undefined') {
            return
          }
          if (this.posizioni.length > 0) {


            this.formAnagrafica.itemOption('causaleRifiuti.idTipoOperazione', 'disabled', true);
            this.formAnagrafica.itemOption('causaleRifiuti.idOperazione', 'disabled', true);
            this.formAnagrafica.itemOption('causaleRifiuti.trasporto', 'disabled', true);
            this.formAnagrafica.itemOption('causaleRifiuti.listaOperazioniRD', 'disabled', true);
            this.formAnagrafica.itemOption('altreInformazioni.stampaRegistriAziendali', 'disabled', true);
            this.formAnagrafica.itemOption('altreInformazioni.spurghi', 'disabled', true);
            this.formAnagrafica.itemOption('causaleRifiuti.prodottoDaGestione', 'disabled', true);
          }
        })



      }



      if (this.SubjectCall == 'CausaliAvanzate') {
        const formData = e.formData
        const idOperazione = this.filterID['idOperazione']

        this.formAnagrafica.itemOption('causaliAvanzate.caricoAutomaticoRifiutiProdotti_Descrizione', 'disabled', true);
        //this.formAnagrafica.itemOption('causaliAvanzate.caricoAutomaticoRifiutiprodotti_label', 'cssClass', 'd-none');

        this.formAnagrafica.itemOption('causaliAvanzate.caricoAutomaticoRifiutiProdotti', 'disabled', true);
        this.formAnagrafica.itemOption('causaliAvanzate.caricoAutomaticoRifiutiDaLavorazione', 'disabled', true);
        this.formAnagrafica.itemOption('causaliAvanzate.caricoAutomaticoRifiutiDaLavorazione', 'disabled', true);
        //this.formAnagrafica.itemOption('causaliAvanzate.caricoAutomaticoRifiutiDaLavorazione_label', 'disabled',true);
        this.formAnagrafica.itemOption('causaliAvanzate.Caricodamiscelazione_label', 'disabled', true);
        this.formAnagrafica.itemOption('causaliAvanzate.caricoDaMiscelazione', 'disabled', true);
        this.formAnagrafica.itemOption('causaliAvanzate.attivaRintracciabilita', 'disabled', true);
        //this.formAnagrafica.itemOption('causaliAvanzate.partecipaAllaMiscelazione_label', 'disabled',true);
        this.formAnagrafica.itemOption('causaliAvanzate.partecipaAllaMiscelazione', 'disabled', true);
        this.formAnagrafica.itemOption('causaliAvanzate.relazioniOperazioniCarico', 'disabled', true);
        this.formAnagrafica.itemOption('causaliAvanzate.scaricaDeposito', 'disabled', true);
        this.formAnagrafica.itemOption('causaliAvanzate.scaricaRicevuti', 'disabled', true);
        this.formAnagrafica.itemOption('causaliAvanzate.scaricaRifiutiProdotti', 'disabled', true);

        if (idOperazione == 'B2') {

          this.formAnagrafica.itemOption('causaliAvanzate.caricoAutomaticoRifiutiProdotti_Descrizione', 'disabled', false);


          this.formAnagrafica.itemOption('causaliAvanzate.caricoAutomaticoRifiutiProdotti', 'disabled', false);
          this.formAnagrafica.itemOption('causaliAvanzate.caricoAutomaticoRifiutiDaLavorazione', 'disabled', true);


        }

        if (idOperazione == 'B1') {
          this.formAnagrafica.itemOption('causaliAvanzate.caricoAutomaticoRifiutiDaLavorazione', 'disabled', false);
          this.formAnagrafica.itemOption('causaliAvanzate.caricoAutomaticoRifiutiDaLavorazione_label', 'disabled', false);

        }

        /* 
        modifica 28-29/08/2023
        
        if (idOperazione == 'A1' || idOperazione == 'A2' || idOperazione == 'A3' || idOperazione == 'A4' || idOperazione == 'A5' || idOperazione == 'A6' || idOperazione == 'A7' || idOperazione == 'A8') {
          this.formAnagrafica.itemOption('causaliAvanzateVarie', 'disabled',true);
          this.formAnagrafica.itemOption('causaliAvanzateVarie', 'colSpan', 2);
          this.formAnagrafica.itemOption('causaliAvanzateVarie', 'cssClass', '');
        }
  
        if (idOperazione == 'C1' || idOperazione == 'C2' || idOperazione == 'D1' || idOperazione == 'D2' || idOperazione == 'D3') {
          this.formAnagrafica.itemOption('causaliAvanzateVarie', 'disabled',true);
          this.formAnagrafica.itemOption('causaliAvanzateVarie', 'colSpan', 2);
          this.formAnagrafica.itemOption('causaliAvanzateVarie', 'cssClass', '');
        } */

        /**Modifica del 11-13/09/2023 */
        if ((idOperazione == 'A1' || idOperazione == 'A2') && this.filterID['prodottoDaGestione'] == 'S') {

          this.formAnagrafica.itemOption('causaliAvanzate.Caricodamiscelazione_label', 'disabled', false);
          this.formAnagrafica.itemOption('causaliAvanzate.caricoDaMiscelazione', 'disabled', false);
          this.formAnagrafica.itemOption('causaliAvanzate.attivaRintracciabilita', 'disabled', false);

        }

        if (idOperazione == 'B1') {
          this.formAnagrafica.itemOption('causaliAvanzate.partecipaAllaMiscelazione_label', 'disabled', false);
          this.formAnagrafica.itemOption('causaliAvanzate.partecipaAllaMiscelazione', 'disabled', false);
        }

        if (idOperazione == 'B1' || idOperazione == 'B2' || idOperazione == 'B3') {

          this.formAnagrafica.itemOption('causaliAvanzate.relazioniOperazioniCarico', 'disabled', false);
          this.formAnagrafica.itemOption('causaliAvanzate.scaricaDeposito', 'disabled', false);
          this.formAnagrafica.itemOption('causaliAvanzate.scaricaRicevuti', 'disabled', false);
          this.formAnagrafica.itemOption('causaliAvanzate.scaricaRifiutiProdotti', 'disabled', false);

          setTimeout(() => {
            /* console.log('formData-->', formData)
            let scaricaDeposito = formData.scaricaDeposito;
            let scaricaRicevuti = formData.scaricaRicevuti;
            let scaricaRifiutiProdotti = formData.scaricaRifiutiProdotti;
            e.getEditor('scaricaDeposito').option('value', scaricaDeposito)
            e.getEditor('scaricaRicevuti').option('value', scaricaRicevuti)
            e.getEditor('scaricaRifiutiProdotti').option('value', scaricaRifiutiProdotti) */

          }, 400);
        }

        if (!this.filterID['isEdit']) {
          this.formAnagrafica.formRefreshInputData('scaricaDeposito', true)
          this.formAnagrafica.formRefreshInputData('scaricaRicevuti', true)
          this.formAnagrafica.formRefreshInputData('scaricaRifiutiProdotti', true)
        }


      }



      if (this.SubjectCall == 'PosizioneCausale') {


        this.posizioniCausaliFormRender(e)


      }
    }

  }

  //* idRegistroTrasporto  ->  idTrasportatore
  //* idRegistroCarico  ->  idDestinatario
  //* Operaz.di scarico su  -> idProduttore

  /******************Modfifica la Form delle posizioni ******************/
  posizioniCausaliFormRender(e) {
    console.log('posizioniCausaliFormRender', this.formAnagrafica)
    console.log('posizioniCausaliFormRender', this.arrayRegistri)


    const filter = this.filterID
    const idOperazione = filter.idOperazione;

    if (this.filterID['isEdit']) {
      this.api.GetApi('RegistroRifiuti').then((res: any) => {
        this.arrayRegistri = res
        if (this.formAnagrafica.dataSet['idTrasportatore']) {
          this.formAnagrafica.elementRef['idRegistroTrasporto'].component.optionData = this.arrayRegistri.filter(i => i.idSede == this.formAnagrafica.dataSet['idTrasportatore'])
        }
        if (this.formAnagrafica.dataSet['idDestinatario']) {
          this.formAnagrafica.elementRef['idRegistroCarico'].component.optionData = this.arrayRegistri.filter(i => i.idSede == this.formAnagrafica.dataSet['idDestinatario'])
        }
        if (this.formAnagrafica.dataSet['idIntermediario']) {
          this.formAnagrafica.elementRef['idRegistroIntermediario'].component.optionData = this.arrayRegistri.filter(i => i.idSede == this.formAnagrafica.dataSet['idIntermediario'])
        }
      })

      this.api.GetApi('Sede/GetSediNsAziende').then((result: any) => {
        const idSedeProduttore = this.formAnagrafica.dataSet.idProduttore
        const idSedeDestinatario = this.formAnagrafica.dataSet.idDestinatario
        const idSedeTrasportatore = this.formAnagrafica.dataSet.idTrasportatore
        const idSedeIntermediario = this.formAnagrafica.dataSet.idIntermediario

        if (idSedeProduttore !== null) {
          const filterSedeProduttore = result.filter(item => item.id == idSedeProduttore)[0]
          this.formAnagrafica.dataSet.idSedeRentri = filterSedeProduttore.idSedeRentri
        }

        if (idSedeDestinatario !== null) {
          const filterSedeDestinatario = result.filter(item => item.id == idSedeDestinatario)[0]
          this.formAnagrafica.dataSet.idSedeRentriDestinatario = filterSedeDestinatario.idSedeRentri
        }

        if (idSedeTrasportatore !== null) {
          const filterSedeTrasportatore = result.filter(item => item.id == idSedeTrasportatore)[0]
          this.formAnagrafica.dataSet.idSedeRentriTrasportatore = filterSedeTrasportatore.idSedeRentri
        }

        if (idSedeIntermediario !== null) {
          const filterSedeIntermediario = result.filter(item => item.id == idSedeIntermediario)[0]
          this.formAnagrafica.dataSet.idSedeRentriIntermediario = filterSedeIntermediario.idSedeRentri
        }

        if (idOperazione == 'A1' || idOperazione == 'A2' || idOperazione == 'A3' || idOperazione == 'A8' || idOperazione == 'B1') {
          console.log('stampo this.formAnagrafica.dataSet', this.formAnagrafica.dataSet)
          this.formAnagrafica.dataSet.descrizioneSede_IdDestinatario = this.formAnagrafica.dataSet.descrizioneSede_IdProduttore
          this.formAnagrafica.dataSet.idSedeRentriDestinatario = this.formAnagrafica.dataSet.idSedeRentri
          this.formAnagrafica.itemOption('datiSmaltimento.descrizioneSede_IdDestinatario', 'disabled', true)
        }
      }).catch((error: any) => {

      })
      // this.formAnagrafica.itemOption('dataPosizioneCausale.idPosizioneDesc', 'disabled', true)
      if (this.formAnagrafica.dataSet['idTrasportatore']) {
        this.formAnagrafica.itemOption('datiTrasportatore.idRegistroTrasporto', 'disabled', this.formAnagrafica.dataSet['idTrasportatore'] === null)
      }
      if (this.formAnagrafica.dataSet['idDestinatario']) {
        this.formAnagrafica.itemOption('datiSmaltimento.idRegistroCarico', 'disabled', this.formAnagrafica.dataSet['idDestinatario'] === null)
      }
      if (this.formAnagrafica.dataSet['idIntermediario']) {
        this.formAnagrafica.itemOption('datiIntermediario.idRegistroIntermediario', 'disabled', this.formAnagrafica.dataSet['idIntermediario'] === null)
      }
      if (this.formAnagrafica.dataSet['idProduttore']) {
        //this.formAnagrafica.itemOption('datiProduttore.idRegistroScarico', 'disabled', this.formAnagrafica.dataSet['idProduttore'] === null)
      }

    }

    this.formAnagrafica.itemOption('datiProduttore', 'cssClass', 'd-none');
    this.formAnagrafica.itemOption('datiSmaltimento', 'cssClass', 'd-none');
    this.formAnagrafica.itemOption('datiTrasportatore', 'cssClass', 'd-none');
    this.formAnagrafica.itemOption('datiIntermediario', 'cssClass', 'd-none');



    if (idOperazione == 'A1' || idOperazione == 'A2' || idOperazione == 'A3') {
      this.formAnagrafica.itemOption('datiSmaltimento.descrizioneSede_IdDestinatario', 'disabled', true)
      this.formAnagrafica.itemOption('datiProduttore', 'cssClass', '');
      this.formAnagrafica.itemOption('datiSmaltimento', 'cssClass', '')

    }

    if (idOperazione == 'A1') {
      this.formAnagrafica.itemOption('datiSmaltimento.descrizioneSede_IdDestinatario', 'setLabel', "U.L. Deposito temporaneo")
      //this.formAnagrafica.itemOption('datiSmaltimento', 'caption', "Deposito temporaneo")
    }

    if (idOperazione == 'A1' || idOperazione == 'A2') {
      this.formAnagrafica.itemOption('datiProduttore.idRegistroScarico', 'validationRules', null)



      this.formAnagrafica.itemOption('datiProduttore.idRegistroScarico', 'placeholder', '************************************************************************');
      this.formAnagrafica.itemOption('datiProduttore.idRegistroScarico', 'disabled', true);

      console.log('descrizioneSede_IdProduttore', this.formAnagrafica.dataSet)

      this.formAnagrafica.itemOption('datiProduttore.idRegistroRentriScarico', 'disabled', true);


    }

    if (idOperazione == 'A4' || idOperazione == 'A5') {

      this.formAnagrafica.itemOption('datiProduttore', 'cssClass', '');
      this.formAnagrafica.itemOption('datiSmaltimento', 'cssClass', '');

      this.formAnagrafica.itemOption('datiProduttore.descrizioneSede_IdProduttore', 'disabled', true);



      this.formAnagrafica.itemOption('datiProduttore.descrizioneSede_IdProduttore', 'validationRules', null);
      this.formAnagrafica.itemOption('datiProduttore.idRegistroScarico', 'validationRules', null)
      this.formAnagrafica.itemOption('datiProduttore.descrizioneSede_IdProduttore', 'placeholder', '******************');

      this.formAnagrafica.itemOption('datiProduttore.idRegistroScarico', 'placeholder', '******************');
      this.formAnagrafica.itemOption('datiProduttore.idRegistroScarico', 'disabled', true);

      this.formAnagrafica.itemOption('datiProduttore.idRegistroRentriScarico', 'disabled', true);
      this.formAnagrafica.itemOption('datiProduttore.idRegistroRentriScarico', 'placeholder', '******************');

    }

    if (idOperazione == 'A6' || idOperazione == 'A7') {
      this.formAnagrafica.itemOption('datiProduttore', 'cssClass', '');
      this.formAnagrafica.itemOption('datiSmaltimento', 'cssClass', '');

      this.formAnagrafica.itemOption('datiProduttore.descrizioneSede_IdProduttore', 'validationRules', null);

      this.formAnagrafica.itemOption('datiProduttore.idRegistroScarico', 'validationRules', null)
      this.formAnagrafica.itemOption('datiProduttore.idRegistroScarico', 'placeholder', '******************');
      this.formAnagrafica.itemOption('datiProduttore.idRegistroScarico', 'disabled', true);


      if (idOperazione == 'A6') {
        let validationRules = [{
          type: 'required',
          message: 'Registro carico obbligatorio'
        }]


        this.formAnagrafica.itemOption('datiSmaltimento.idRegistroCarico', 'validationRules', validationRules)

      }

      // this.formAnagrafica.itemOption('datiSmaltimento.idRegistroCarico', 'validationRules', validationRules)
    }

    if (idOperazione == 'A8') {
      this.formAnagrafica.itemOption('datiProduttore', 'cssClass', '');
      // this.formAnagrafica.itemOption('datiSmaltimento', 'cssClass', '')
      this.formAnagrafica.itemOption('datiProduttore.idRegistroScarico', 'validationRules', null)
      // this.formAnagrafica.itemOption('datiProduttore.idRegistroScarico', 'placeholder', '******************');
      this.formAnagrafica.itemOption('datiProduttore.idRegistroScarico', 'disabled', true);
      this.formAnagrafica.itemOption('datiSmaltimento.descrizioneSede_IdDestinatario', 'disabled', true)

    }

    if (idOperazione == 'B1') {
      this.formAnagrafica.itemOption('datiProduttore', 'cssClass', '');
      this.formAnagrafica.itemOption('datiSmaltimento', 'cssClass', '')
      this.formAnagrafica.itemOption('datiSmaltimento.idRegistroCarico', 'validationRules', null)
      this.formAnagrafica.itemOption('datiSmaltimento.descrizioneSede_IdDestinatario', 'disabled', true)
      this.formAnagrafica.itemOption('datiSmaltimento.idRegistroCarico', 'placeholder', '******************');
      this.formAnagrafica.itemOption('datiSmaltimento.idRegistroCarico', 'disabled', true);
      this.formAnagrafica.itemOption('datiProduttore.idRegistroScarico', 'disabled', this.formAnagrafica.dataSet['idProduttore'] === null);
    }

    if (idOperazione == 'B2') {
      this.formAnagrafica.itemOption('datiProduttore', 'cssClass', '');
      this.formAnagrafica.itemOption('datiSmaltimento', 'cssClass', '');

      this.formAnagrafica.itemOption('datiSmaltimento.descrizioneSede_IdDestinatario', 'disabled', true)
      this.formAnagrafica.itemOption('datiSmaltimento.descrizioneSede_IdDestinatario', 'validationRules', null)
      this.formAnagrafica.itemOption('datiProduttore.idRegistroScarico', 'disabled', this.formAnagrafica.dataSet['idProduttore'] === null);
      this.formAnagrafica.itemOption('datiSmaltimento.idRegistroCarico', 'validationRules', null)
      this.formAnagrafica.itemOption('datiSmaltimento.descrizioneSede_IdDestinatario', 'placeholder', '******************');
      this.formAnagrafica.itemOption('datiSmaltimento.idRegistroCarico', 'placeholder', '****************');
      this.formAnagrafica.itemOption('datiSmaltimento.idRegistroCarico', 'disabled', true);


    }

    if (idOperazione == 'B3') {
      this.formAnagrafica.itemOption('datiProduttore', 'cssClass', '');
      this.formAnagrafica.itemOption('datiSmaltimento', 'cssClass', '');
      this.formAnagrafica.itemOption('datiProduttore.idRegistroScarico', 'disabled', this.formAnagrafica.dataSet['idProduttore'] === null);
      this.formAnagrafica.itemOption('datiSmaltimento.descrizioneSede_IdDestinatario', 'validationRules', null)
      this.formAnagrafica.itemOption('datiSmaltimento.idRegistroCarico', 'validationRules', null)

      this.formAnagrafica.itemOption('datiSmaltimento.idRegistroCarico', 'placeholder', '******************');
      this.formAnagrafica.itemOption('datiSmaltimento.idRegistroCarico', 'disabled', true);



    }


    if (idOperazione == 'C1') {
      //this.formAnagrafica.itemOption('datiSmaltimento', 'cssClass', '');
      if (filter.trasporto !== 'T')
        this.formAnagrafica.itemOption('datiTrasportatore', 'cssClass', '');



      let validationRules = [{
        type: 'required',
        message: 'Registro trasporto obbligatorio'
      }]

      this.formAnagrafica.itemOption('datiTrasportatore.idRegistroTrasporto', 'validationRules', validationRules);

      this.formAnagrafica.itemOption('datiProduttore.descrizioneSede_IdProduttore', 'validationRules', null);
      this.formAnagrafica.itemOption('datiProduttore.idRegistroScarico', 'validationRules', null);

      this.formAnagrafica.itemOption('datiSmaltimento.descrizioneSede_IdDestinatario', 'validationRules', null);
      this.formAnagrafica.itemOption('datiSmaltimento.idRegistroCarico', 'validationRules', null);

    }

    if (idOperazione == 'C2') {
      if (filter.trasporto !== 'T')
        this.formAnagrafica.itemOption('datiTrasportatore', 'cssClass', '');

      this.formAnagrafica.removeClassToGroup('datiIntermediario', 'd-none');

      let validationRules = [{
        type: 'required',
        message: 'Intermediario obbligatorio'
      }]

      this.formAnagrafica.itemOption('datiIntermediario.descrizioneSede_IdIntermediario', 'validationRules', validationRules);

      this.formAnagrafica.itemOption('datiProduttore.descrizioneSede_IdProduttore', 'validationRules', null);
      this.formAnagrafica.itemOption('datiProduttore.idRegistroScarico', 'validationRules', null);

      this.formAnagrafica.itemOption('datiSmaltimento.descrizioneSede_IdDestinatario', 'validationRules', null);
      this.formAnagrafica.itemOption('datiSmaltimento.idRegistroCarico', 'validationRules', null);
    }

    //datiTrasportatore
    const trasporto = filter.trasporto
    if ((trasporto == 'P' || trasporto == 'X') && idOperazione != 'C2') {

      this.formAnagrafica.removeClassToGroup('datiTrasportatore', 'd-none');
      let validationRules = [{
        type: 'required',
        message: 'Trasporto obbligatorio'
      }]
      this.formAnagrafica.itemOption('datiTrasportatore.descrizioneSede_IdTrasportatore', 'validationRules', validationRules);

    }

    if (idOperazione == 'D3') {
      this.formAnagrafica.removeClassToGroup('datiProduttore', 'd-none');
      this.formAnagrafica.removeClassToGroup('datiSmaltimento', 'd-none');

      this.formAnagrafica.itemOption('datiSmaltimento.descrizioneSede_IdDestinatario', 'disabled', true)
      this.formAnagrafica.itemOption('datiSmaltimento.descrizioneSede_IdDestinatario', 'validationRules', null)

      this.formAnagrafica.itemOption('datiSmaltimento.idRegistroCarico', 'validationRules', null)
      this.formAnagrafica.itemOption('datiSmaltimento.descrizioneSede_IdDestinatario', 'placeholder', '******************');
      this.formAnagrafica.itemOption('datiSmaltimento.idRegistroCarico', 'disabled', true);
      this.formAnagrafica.itemOption('datiSmaltimento.idRegistroRentriCarico', 'disabled', true);

      this.formAnagrafica.itemOption('datiProduttore.descrizioneSede_IdProduttore', 'placeholder', '****************');
      this.formAnagrafica.itemOption('datiProduttore.descrizioneSede_IdProduttore', 'validationRules', null);
      this.formAnagrafica.itemOption('datiProduttore.descrizioneSede_IdProduttore', 'disabled', true);

      this.formAnagrafica.itemOption('datiProduttore.idRegistroScarico', 'disabled', true);
      this.formAnagrafica.itemOption('datiProduttore.idRegistroRentriScarico', 'disabled', true);
      this.formAnagrafica.itemOption('datiProduttore.idRegistroScarico', 'validationRules', null);


      /* this.formAnagrafica.itemOption('datiTrasportatore.descrizioneSede_IdTrasportatore', 'placeholder', '****************');
      this.formAnagrafica.itemOption('datiProduttore.descrizioneSede_IdProduttore', 'validationRules', null);
      this.formAnagrafica.itemOption('datiProduttore.idRegistroScarico', 'disabled', true);
      this.formAnagrafica.itemOption('datiProduttore.idRegistroScarico', 'validationRules', null); */


    }

    const stampaRegistriAziendali = this.filterID['stampaRegistriAziendali'];
    if (stampaRegistriAziendali == '0') {
      this.formAnagrafica.itemOption('datiProduttore.idRegistroScarico', 'validationRules', null);
      this.formAnagrafica.itemOption('datiSmaltimento.idRegistroCarico', 'validationRules', null);
      this.formAnagrafica.itemOption('datiTrasportatore.idRegistroTrasporto', 'validationRules', null);
      this.formAnagrafica.itemOption('datiIntermediario.idRegistroIntermediario', 'validationRules', null);
    }






  }



  tabClick(ev) {

    const itemData = ev.itemData;

    if (itemData.service == this.SubjectCall) {
      return
    }

    let data = [];

    if (this.template == 'form') {
      const validation = this.formAnagrafica.validate();
      if (validation.isValid) {

        //this.formAnagrafica.onFormSubmit();
      } else {

        return
      }
    }

    setTimeout(() => {

      switch (this.SubjectCall) {
        /*
          Quando Sono nella TAB AlboCategoria devo passare i dati alle altre tab.
          il dato costante da inviare è alle tab relazionate id ovvero idAlboCategoria
    
        */


        case 'CausaliRifiuti':


          data = this.formAnagrafica.dataSet;

          if (itemData.service == 'CausaliAvanzate') {
            this.filterID = data;

          }
          this.filterID['idCausale'] = data['id'];
          this.filterID['isEdit'] = true

          if (typeof this.filterID['templateTab'] != 'undefined') {

            this.filterID['templateTab']['CausaliRifiuti'] = this.template;

          } else {

            this.filterID['templateTab'] = this.templateTab;
            this.filterID['templateTab']['CausaliRifiuti'] = this.template;

          }

          this.filterID['idOperazione'] = data['idOperazione']
          this.filterID['descCausale'] = data['descrizione'];
          this.filterID['prodottoDaGestione'] = data['prodottoDaGestione'];
          /* this.filterID['scaricaDeposito'] = data['scaricaDeposito'];
          this.filterID['scaricaRicevuti'] = data['scaricaRicevuti'];
          this.filterID['scaricaRifiutiProdotti'] = data['scaricaRifiutiProdotti']; */

          if (itemData.service == 'PosizioneCausale') {
            this.filterID['idCausale'] = data['id'];
            this.filterID['trasporto'] = data['trasporto'];
            this.filterID['stampaRegistriAziendali'] = data['stampaRegistriAziendali'];
            this.filterID['prodottoDaGestione'] = data['prodottoDaGestione'];
            if (typeof this.filterID['idPosizione'] != 'undefined') {
              data['id'] = this.filterID['idPosizione']
            }



          }




          break;

        case 'CausaliAvanzate':
          this.filterID['isEdit'] = true;
          data = this.formAnagrafica.dataSet;

          if (typeof this.filterID['templateTab'] != 'undefined') {
            this.filterID['templateTab']['CausaliAvanzate'] = 'form'
          } else {
            this.filterID['templateTab'] = this.templateTab;
            this.filterID['templateTab']['CausaliAvanzate'] = 'form'
          }
          this.filterID['idOperazione'] = data['idOperazione']
          this.filterID['idCausale'] = data['id']
          this.filterID['descCausale'] = data['descrizione'];
          if (itemData.service == 'PosizioneCausale') {

            data['id'] = this.filterID['idPosizione']
            this.filterID['trasporto'] = data['trasporto'];
            this.filterID['stampaRegistriAziendali'] = data['stampaRegistriAziendali']
          }
          break;

        case 'PosizioneCausale':

          if (typeof this.formAnagrafica != 'undefined') {
            data = this.formAnagrafica.dataSet;
          }
          this.filterID['isEdit'] = true;
          if (typeof this.filterID['templateTab'] != 'undefined') {
            //this.filterID['templateTab']['PosizioneCusale'] = this.template
          } else {
            this.filterID['templateTab'] = this.templateTab;
            //this.filterID['templateTab']['PosizioneCusale'] = this.template
          }
          //this.filterID['idOperazione'] = data['idPosizione']
          //this.filterID['idPosizione'] = data['id']
          data['id'] = this.filterID['idCausale'];

          break;

      }


      this.refreshPage(data, '', itemData.service, this.filterID['templateTab'][itemData.service], itemData);


    }, 300);



  }

  formEventCausali(event) {
    let name = event.name;
    let template;
    let data = event.formData;
    switch (name) {
      case 'submittedEditOk':
        if (this.SubjectCall == 'PosizioneCausale') {
          template = 'grid'
          this.refreshPage(data, '', this.SubjectCall, template);
          return
        }

        this.formEvent(event)
        break;
      case 'submittedInsertOk':
        if (this.SubjectCall == 'PosizioneCausale') {
          template = 'grid'
          this.refreshPage(data, '', this.SubjectCall, template);
          return
        }

        this.formEvent(event)
        break;
      case 'return':
        if (this.SubjectCall == 'CausaliAvanzate') {
          template = 'grid'
          this.filterID = [];
          if (event && event.data)
            delete event.data.descrizione
          this.refreshPage([], '', 'CausaliRifiuti', template);
          return
        }
        if (this.SubjectCall != 'PosizioneCausale') {
          this.filterID = [];
          if (event && event.data)
            delete event.data.descrizione;
          this.refreshPage([], '', 'CausaliRifiuti', template);
          return
        }
        this.formEvent(event)
        break;


      default:
        this.formEvent(event)
        break;
    }

  }
}
